var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-banner"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.bannerImg),expression:"bannerImg"}],staticClass:"mobile-banner-img",attrs:{"src":_vm.bannerImg}})])
}
var staticRenderFns = []

export { render, staticRenderFns }